import { Box } from '@oneloop/jopijs';
import ToolTip from '@/components/ToolTip/ToolTip';
import ImageNext from '@/components/shared/ImageNext';
import LightbulbIcon from '../../../public/images/lightbulb.png';
import styles from './styles.module.scss';

export default function DynamicTags({ handleDropdown }) {
  const handleOpenDynamicTagsPicker = () => {
    handleDropdown({ open: true });
  };

  return (
    <ToolTip title="Dynamic tags">
      <Box
        as="button"
        className={styles['outer-wrapper']}
        onClick={handleOpenDynamicTagsPicker}
      >
        <Box className={styles['inner-wrapper']}>
          <ImageNext alt="message-templates-icon" src={LightbulbIcon} />
        </Box>
      </Box>
    </ToolTip>
  );
}
